import { render, staticRenderFns } from "./childLink.vue?vue&type=template&id=b0ddccde&"
import script from "./childLink.vue?vue&type=script&lang=js&"
export * from "./childLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports